<template>
  <div>
    <breadcrumb/>
    <post-list category="Factoring-Marketing Interno y Campañas - Campañas"></post-list>
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>